module.exports = __webpack_public_path__ + "static/crazy_rich_asians_1920x900-tablet.6afc5372.png";